import React from 'react'

/**
 * First-try Stock: the why is the first screen. Permissions, Main vs Partial,
 * and Create sit below until they have a take.
 */
const StockTakesAboveFoldLayout = ({ liftEmpty, why, children }) => {
  if (liftEmpty) {
    return (
      <div data-testid='stock-takes-above-fold'>
        <div data-testid='stock-takes-why'>{why}</div>
        <div data-testid='stock-takes-deferred-chrome'>{children}</div>
      </div>
    )
  }

  return <div data-testid='stock-takes-above-fold'>{children}</div>
}

export default StockTakesAboveFoldLayout
